import React from 'react';
import {useTranslation} from 'react-i18next';
import {useUiVersion, UI_VERSION_V2} from "../../../context/UserModulesContext";

/**
 * Camino de vuelta al Dashbo nuevo desde el sidebar clásico. Solo aparece para usuarios cuya
 * agencia está en el piloto y que eligieron volver a v1 — para el resto no renderiza nada, así el
 * sidebar de siempre queda intacto.
 */
export function BackToUiV2Button() {
    const {t} = useTranslation();
    const {canUseV2, isV2, setUiVersion} = useUiVersion();

    if (!canUseV2 || isV2) return null;

    return (
        <button
            className="sidebar-main-link ui-v2-optin-button"
            onClick={() => setUiVersion(UI_VERSION_V2)}
            title={t('topbar_v2.try_new_dashbo')}
        >
            <span className="ui-v2-optin-badge">2.1</span>
            <span className="tooltip-text">{t('topbar_v2.try_new_dashbo')}</span>
        </button>
    );
}

export default BackToUiV2Button;
